module.exports = __webpack_public_path__ + "static/media/ASLA_FL Logo.4ca39496.png";